export const baseUrl = '/company-treatment-categories'
